// Theme: mocha-mousse
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'mocha-mousse',
  name: 'MOCHA MOUSSE',
  tagline: 'MOCHA MOUSSE',
  description: 'Mocha quente e suave em trilha free com progressao constante.',
  category: 'organic-world',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#2F2A26', '#C4956A', '#3D3630', '#E6D5C7'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 10px 24px rgba(0, 0, 0, 0.18)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 6%, transparent)'
    },
    shellClasses: 'font-sans theme-mocha-mousse'
  },
  colorVars: {
    '--accent': '#C4956A',
    '--accent-foreground': '#2F2A26',
    '--background': '#2F2A26',
    '--border': '#8B6A4F',
    '--card': '#3D3630',
    '--card-border-active': 'rgba(196, 149, 106, 0.34)',
    '--card-completed': '#3D3630',
    '--card-foreground': '#E6D5C7',
    '--card-glow': 'rgba(196, 149, 106, 0.06)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#2F2A26',
    '--foreground': '#E6D5C7',
    '--hold-fill': '#C4956A',
    '--input': '#3D3630',
    '--modal-bg': '#2F2A26',
    '--modal-border': '#8B6A4F',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 24px rgba(0, 0, 0, 0.18)',
    '--muted': '#8B6A4F',
    '--muted-foreground': '#E6D5C7',
    '--nav-active': '#C4956A',
    '--nav-bg': '#2F2A26',
    '--popover': '#3D3630',
    '--popover-foreground': '#E6D5C7',
    '--primary': '#C4956A',
    '--primary-foreground': '#2F2A26',
    '--ring': '#C4956A',
    '--secondary': '#8B6A4F',
    '--secondary-foreground': '#E6D5C7',
    '--streak': '#C4956A',
    '--success': '#22C55E',
    '--success-foreground': '#2F2A26',
    '--xp': '#C4956A',
    '--xp-bg': '#3D3630'
  },
  resolvedVars: {
    '--accent': '#C4956A',
    '--accent-foreground': '#2F2A26',
    '--accent-foreground-hsl': '27 11% 17%',
    '--accent-foreground-oklch': 'from #2F2A26 l c h',
    '--accent-hsl': '29 43% 59%',
    '--accent-oklch': 'from #C4956A l c h',
    '--background': '#2F2A26',
    '--background-hsl': '27 11% 17%',
    '--background-oklch': 'from #2F2A26 l c h',
    '--border': '#8B6A4F',
    '--border-hsl': '27 28% 43%',
    '--border-oklch': 'from #8B6A4F l c h',
    '--border-w': '1px',
    '--card': '#3D3630',
    '--card-border-active': 'rgba(196, 149, 106, 0.34)',
    '--card-completed': '#3D3630',
    '--card-completed-hsl': '28 12% 21%',
    '--card-completed-oklch': 'from #3D3630 l c h',
    '--card-foreground': '#E6D5C7',
    '--card-foreground-hsl': '27 38% 84%',
    '--card-foreground-oklch': 'from #E6D5C7 l c h',
    '--card-glow': 'rgba(196, 149, 106, 0.06)',
    '--card-hsl': '28 12% 21%',
    '--card-oklch': 'from #3D3630 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#2F2A26',
    '--destructive-foreground-hsl': '27 11% 17%',
    '--destructive-foreground-oklch': 'from #2F2A26 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#E6D5C7',
    '--foreground-hsl': '27 38% 84%',
    '--foreground-oklch': 'from #E6D5C7 l c h',
    '--hold-fill': '#C4956A',
    '--hold-fill-hsl': '29 43% 59%',
    '--hold-fill-oklch': 'from #C4956A l c h',
    '--input': '#3D3630',
    '--input-hsl': '28 12% 21%',
    '--input-oklch': 'from #3D3630 l c h',
    '--modal-bg': '#2F2A26',
    '--modal-bg-hsl': '27 11% 17%',
    '--modal-bg-oklch': 'from #2F2A26 l c h',
    '--modal-border': '#8B6A4F',
    '--modal-border-hsl': '27 28% 43%',
    '--modal-border-oklch': 'from #8B6A4F l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 24px rgba(0, 0, 0, 0.18)',
    '--muted': '#8B6A4F',
    '--muted-foreground': '#E6D5C7',
    '--muted-foreground-hsl': '27 38% 84%',
    '--muted-foreground-oklch': 'from #E6D5C7 l c h',
    '--muted-hsl': '27 28% 43%',
    '--muted-oklch': 'from #8B6A4F l c h',
    '--nav-active': '#C4956A',
    '--nav-active-hsl': '29 43% 59%',
    '--nav-active-oklch': 'from #C4956A l c h',
    '--nav-bg': '#2F2A26',
    '--nav-bg-hsl': '27 11% 17%',
    '--nav-bg-oklch': 'from #2F2A26 l c h',
    '--popover': '#3D3630',
    '--popover-foreground': '#E6D5C7',
    '--popover-foreground-hsl': '27 38% 84%',
    '--popover-foreground-oklch': 'from #E6D5C7 l c h',
    '--popover-hsl': '28 12% 21%',
    '--popover-oklch': 'from #3D3630 l c h',
    '--primary': '#C4956A',
    '--primary-foreground': '#2F2A26',
    '--primary-foreground-hsl': '27 11% 17%',
    '--primary-foreground-oklch': 'from #2F2A26 l c h',
    '--primary-hsl': '29 43% 59%',
    '--primary-oklch': 'from #C4956A l c h',
    '--radius': '12px',
    '--ring': '#C4956A',
    '--ring-hsl': '29 43% 59%',
    '--ring-oklch': 'from #C4956A l c h',
    '--secondary': '#8B6A4F',
    '--secondary-foreground': '#E6D5C7',
    '--secondary-foreground-hsl': '27 38% 84%',
    '--secondary-foreground-oklch': 'from #E6D5C7 l c h',
    '--secondary-hsl': '27 28% 43%',
    '--secondary-oklch': 'from #8B6A4F l c h',
    '--shadow-card': '0 10px 24px rgba(0, 0, 0, 0.18)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 6%, transparent)',
    '--streak': '#C4956A',
    '--streak-hsl': '29 43% 59%',
    '--streak-oklch': 'from #C4956A l c h',
    '--success': '#22C55E',
    '--success-foreground': '#2F2A26',
    '--success-foreground-hsl': '27 11% 17%',
    '--success-foreground-oklch': 'from #2F2A26 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(29 43% 59% / 0.15)',
    '--xp': '#C4956A',
    '--xp-bg': '#3D3630',
    '--xp-bg-hsl': '28 12% 21%',
    '--xp-bg-oklch': 'from #3D3630 l c h',
    '--xp-hsl': '29 43% 59%',
    '--xp-oklch': 'from #C4956A l c h'
  }
}
